export const Config = {
    AJAX_URL: window.ambikly_admin?.ajax_url,
} as const;

export type Config = typeof Config[keyof typeof Config]; // Type for message types
